import {fsa, fsaPayloadByKeys} from './helpers'

export const CLOSE_EDIT_PARTICIPANT_FORM = 'closes edit participant form'
export const CLOSE_EVENT_DETAILS = 'closes the dashboard event details'
export const CLOSE_PARTICIPANT_FORM = 'closes participant form'
export const CLOSE_USER_FORM = 'closes user form'
export const EXPAND_HTO_DRAWER = 'expands hto drawer'
export const OPEN_EVENT_DETAILS = 'open the dashboard event details'
export const OPEN_EDIT_PARTICIPANT_FORM = 'opens edit participant form'
export const OPEN_PARTICIPANT_FORM = 'opens participant form'
export const OPEN_USER_FORM = 'opens user form'
export const SET_WEARER_TO_EDIT = 'sets wearer to be edited'
export const SET_SECTIONS_OPEN = 'set sections open inside dashboard'
export const SHOW_EVENT_DETAILS_LIST = 'display event details item list'
export const TOGGLE_EVENT_DETAILS = 'toggles event details dashboard section'
export const REFRESH_DASHBOARD_INITIAL_STATE = 'Refresh Dashboard InitialState'

export function closeEditParticipantForm() {
  return {
    type: CLOSE_EDIT_PARTICIPANT_FORM,
  }
}

export function closeEventDetails() {
  return {
    type: CLOSE_EVENT_DETAILS,
  }
}

export function closeParticipantForm() {
  return {
    type: CLOSE_PARTICIPANT_FORM,
  }
}

export function closeUserForm() {
  return {
    type: CLOSE_USER_FORM,
  }
}

export function expandHtoDrawer() {
  return {
    type: EXPAND_HTO_DRAWER,
  }
}

export const openEventDetails = () => ({type: OPEN_EVENT_DETAILS})

export function openEditParticipantForm() {
  return {
    type: OPEN_EDIT_PARTICIPANT_FORM,
  }
}

export function openParticipantForm() {
  return {
    type: OPEN_PARTICIPANT_FORM,
  }
}

export function openUserForm() {
  return {
    type: OPEN_USER_FORM,
  }
}

export function showEventDetailsList() {
  return {
    type: SHOW_EVENT_DETAILS_LIST,
  }
}

export function toggleEventDetails() {
  return {
    type: TOGGLE_EVENT_DETAILS,
  }
}

export function setWearerToEdit(userEventLookId) {
  return {
    type: SET_WEARER_TO_EDIT,
    userEventLookId,
  }
}

// TODO: This action and it's corresponding reducer are way to loosey-goosey.
export function setSectionsOpen(payload) {
  return {
    type: SET_SECTIONS_OPEN,
    payload,
  }
}

export const ENTER_EVENT_DETAIL_EDIT_MODE = 'enter event detail editing mode'
export const enterEventDetailEditMode = fsaPayloadByKeys(ENTER_EVENT_DETAIL_EDIT_MODE, [
  'eventDetailId',
])

export const LEAVE_EVENT_DETAIL_EDIT_MODE = 'leave event detail editing mode'
export const leaveEventDetailEditMode = fsa(LEAVE_EVENT_DETAIL_EDIT_MODE)

export const VALIDATE_DASHBOARD = 'validate the dashboard'
export const validateDashboard = fsaPayloadByKeys(VALIDATE_DASHBOARD, ['clickEvent'])

export const VALIDATE_DASHBOARD_FAILURE = 'validate the dashboard failure'
export const validateDashboardFailure = fsa(VALIDATE_DASHBOARD_FAILURE)

export const VALIDATE_DASHBOARD_PENDING = 'validate the dashboard pending'
export const validateDashboardPending = fsa(VALIDATE_DASHBOARD_PENDING)

export const VALIDATE_DASHBOARD_SUCCESS = 'validate the dashboard succeeded'
export const validateDashboardSuccess = fsa(VALIDATE_DASHBOARD_SUCCESS)

export const OPEN_DASHBOARD = 'open the dashboard'
export const openDashboard = fsa(OPEN_DASHBOARD)

export const CLOSE_DASHBOARD = 'close the dashboard'
export const closeDashboard = fsa(CLOSE_DASHBOARD)

export const TOGGLE_DASHBOARD = 'toggle the dashboard'
export const toggleDashboard = fsa(TOGGLE_DASHBOARD)
